module.exports = __webpack_public_path__ + "static/img/A2E_Training_Cambodia_solar_2017SSD.3cbf52c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/outreach/A2E_Training_Cambodia_solar_2017SSD.jpg
// module id = xQJ4
// module chunks = 0